<script setup>
import { computed, watch } from 'vue'
import { useEmployeeStore } from '@/stores/employee.js'
import { useRoute } from 'vue-router'
import DefaultLayout from "@/layouts/default.vue";
import EmployeeDetails from "@/components/employee/EmployeeDetails.vue";
import EmployeeStat from "@/components/employee/EmployeeStat.vue";
import EventTimeline from "@/components/common/EventTimeline.vue";
import DirectMessageForm from "@/components/messages/DirectMessageForm.vue";

const route = useRoute()
const employeeStore = useEmployeeStore()

const employeeId = computed(() => route.params.id);
const employee = computed(() => employeeStore.employee);

// Загружаем данные при монтировании и при смене ID в URL
watch(
    employeeId,
    (id) => {
      if (id) {
        employeeStore.loadEmployee(id);
      }
    },
    { immediate: true } // immediate: true запускает загрузку сразу при создании компонента
);
</script>

<template>
  <DefaultLayout>
    <div class="flex h-screen gap-4">
      <div class="flex flex-col w-2/5 h-full">
        <div class="mx-auto w-full max-w-2xl space-y-4">
        <EmployeeDetails :employee="employee" />
          <DirectMessageForm :userId="Number(employeeId)" />
        </div>
      </div>
      <div class="w-3/5 shrink-0 min-w-[250px] max-h-full flex flex-col gap-4">
        <EmployeeStat v-if="employee" :employee="employee" class="flex-shrink-0" />
        <EventTimeline v-if="employeeId" :entity-id="employeeId" target="user" :showUser="true" class="flex-1 min-h-0"/>
      </div>
    </div>
  </DefaultLayout>
</template>